import React from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import Banner from '../../styled/components/single-column-banner';
const ThankYouBanner = ({ buyComplete }) => (React.createElement(Banner, { className: 'flex-dir-col pad pad-top-lg pad-bottom-lg' },
    React.createElement(SRow, { className: 'align-items-center' },
        React.createElement(SCol, { span: '12', center: '', className: 'pad-bottom-none' },
            React.createElement("h1", { className: 'text-center text-xxl font-normal text-white' },
                "Thank you for ",
                buyComplete ? 'purchasing' : 'trying',
                " AvaTax"))),
    React.createElement(SRow, { className: 'justify-content-center' },
        React.createElement(SCol, { span: '8', center: '', className: 'pad-bottom-none margin-top-sm' },
            React.createElement("h2", { className: 'text-center text-white' }, "We'll send you an email with a link to activate your new AvaTax account and set your password.")))));
export default ThankYouBanner;
